var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.935 5.211a1.45 1.45 0 012.465.99v19.598a1.45 1.45 0 01-2.465.99L9.583 21.6h-6.14A1.422 1.422 0 012 20.2v-8.4a1.422 1.422 0 011.444-1.4h6.14zM22.221 23a.599.599 0 01-.471-.232.632.632 0 01.093-.871 7.68 7.68 0 00-.016-11.793.632.632 0 01-.095-.87.592.592 0 01.848-.098 8.942 8.942 0 01.018 13.728.591.591 0 01-.377.136zm1.432 2.8a.625.625 0 01-.49-.239.646.646 0 01.097-.898 11.209 11.209 0 00-.024-17.325.647.647 0 01-.098-.898.621.621 0 01.883-.1 12.5 12.5 0 01.025 19.32.621.621 0 01-.393.14zm-3.235-6.627a4.155 4.155 0 00-.009-6.345.591.591 0 01-.087-.811.544.544 0 01.783-.09 5.334 5.334 0 01.01 8.146.543.543 0 01-.348.127.55.55 0 01-.435-.216.591.591 0 01.086-.81z",
  fillRule: "evenodd"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--volume-up-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'VolumeUpIcon';
export default Icon;